import _get from 'lodash.get';
import { isPrimitive } from '../../helpers/isPrimitive';

export function getAreAllTargetsEmpty(nodes, parent, targetPaths, targetNodes) {
  return !nodes.length && (
    (!parent && targetPaths.length) ||
    (targetNodes.length && targetNodes.every((node) => !node))
  );
}

export function getNodes(targetNodes, parent, targetPaths) {
  const nodes = targetNodes.filter((target) => target).map((target) => ({ target, path: getTargetPath(target) }));
  nodes.push(...getNodesFromTargetPaths(parent, targetPaths));
  return nodes;
}

function getNodesFromTargetPaths(parent, targetPaths) {
  const newTargetNodes = [];

  if (parent) {
    targetPaths.forEach(targetPath => {
      const node = _get(parent, targetPath);

      const parentPath = getTargetPath(parent);
      const fullTargetPath = parentPath ? `${parentPath}.${targetPath}` : undefined;

      newTargetNodes.push({
        target: !isPrimitive(node) ? node : undefined,
        path: getTargetPath(node) || fullTargetPath,
        parentPath
      });
    });
  }

  return newTargetNodes;
}

function getTargetPath(target) {
  return (target || {})[Symbol.for('__fullPath')];
}
